import { Container, Sprite, TextStyle, Text } from "pixi.js";
import { LabelType } from "./LabelType";
import { GameFont } from "../../../../common/GameFont";
import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";
import { PiggyMultiplier } from "../../../../common/components/PiggyMultiplier";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { MarketplaceResourcePackage } from "../../resources/MarketplaceResourcePackage";

export class LabelContainer extends Container {
    private readonly marketplaceResources: MarketplaceResourcePackage;
    private readonly commonResources: CommonResourcesPackage;

    public constructor(marketplaceResources: MarketplaceResourcePackage, commonResources: CommonResourcesPackage, labelType: LabelType, value: number) {
        super();
        this.marketplaceResources = marketplaceResources;
        this.commonResources = commonResources;
        const frame = new Sprite(marketplaceResources.assets_views_marketplace_label_frame_png);
        this.addChild(frame);
        switch (labelType) {
            case LabelType.PIGGY:
                this.createPiggyLabel(value);
                break;
            case LabelType.TOKEN:
                this.createTokenLabel(value);
                break;
        }
    }

    private createPiggyLabel(miltiplier: number): void {
        const piggyIcon = new PiggyMultiplier(this.commonResources);
        piggyIcon.scale.set(0.65);
        piggyIcon.position.set(10, 4);
        this.addChild(piggyIcon);
        const piggyMultiplierText = new Text(`+${Math.round((miltiplier - 1) * 100)}%`, new LabelTextStyle());
        piggyMultiplierText.position.set(miltiplier >= 2 ? 68 : 72, 16);
        this.addChild(piggyMultiplierText);
    }

    private createTokenLabel(count: number): void {
        const tokenIcon = new Sprite(this.marketplaceResources.assets_views_marketplace_token_icon_png);
        tokenIcon.position.set(2, -2);
        this.addChild(tokenIcon);
        const tokenCountText = new Text(`${StringFormatExtention.formatWithComma(count)}`, new LabelTextStyle);
        tokenCountText.anchor.x = 0.5;
        tokenCountText.position.set(96, 17);
        this.addChild(tokenCountText);
    }
}

class LabelTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 28
        }));
    }
}